// Official Amazon Marketplace IDs from SP-API documentation
export const marketplaceOptionsList = [
    // North America
    { name: 'Canada', code: 'CA', id: 'A2EUQ1WTGCTBG2' },
    { name: 'United States', code: 'US', id: 'ATVPDKIKX0DER' },
    { name: 'Mexico', code: 'MX', id: 'A1AM78C64UM0Y8' },
    { name: 'Brazil', code: 'BR', id: 'A2Q3Y263D00KWC' },
    
    // Europe
    { name: 'Spain', code: 'ES', id: 'A1RKKUPIHCS9HS' },
    { name: 'United Kingdom', code: 'GB', id: 'A1F83G8C2ARO7P' },
    { name: 'France', code: 'FR', id: 'A13V1IB3VIYZZH' },
    { name: 'Belgium', code: 'BE', id: 'AMEN7PMS3EDWL' },
    { name: 'Netherlands', code: 'NL', id: 'A1805IZSGTT6HS' },
    { name: 'Germany', code: 'DE', id: 'A1PA6795UKMFR9' },
    { name: 'Italy', code: 'IT', id: 'APJ6JRA9NG5V4' },
    { name: 'Sweden', code: 'SE', id: 'A2NODRKZP88ZB9' },
    { name: 'Poland', code: 'PL', id: 'A1C3SOZRARQ6R3' },
    { name: 'Egypt', code: 'EG', id: 'ARBP9OOSHTCHU' },
    { name: 'Turkey', code: 'TR', id: 'A33AVAJ2PDY3EV' },
    { name: 'Saudi Arabia', code: 'SA', id: 'A17E79C6D8DWNP' },
    { name: 'United Arab Emirates', code: 'AE', id: 'A2VIGQ35RCS4UG' },
    { name: 'India', code: 'IN', id: 'A21TJRUUN4KGV' },
    
    // Far East
    { name: 'Singapore', code: 'SG', id: 'A19VAU5U5O7RUS' },
    { name: 'Australia', code: 'AU', id: 'A39IBJ37TRP1C6' },
    { name: 'Japan', code: 'JP', id: 'A1VC38T7YXB528' }
];